<script>
  import ThumbnailGalleryItem from "@components/ThumbnailGallery/ThumbnailGalleryItem.svelte"

  export let images
  export let selected
  export { className as class }

  let className = ""

  const selectImage = (image) => {
    selected = image
  }
</script>

<div class="{className} thumbnail-gallery grid gap-2 grid-cols-5 md:grid-cols-6 lg:grid-cols-8">
  {#each images as image, i (image.id)}
    <button on:click={() => selectImage(image)} class="w-full aspect-square relative bg-neutral-50">
      <ThumbnailGalleryItem {image} imageIndex={i} selectedImageId={selected.id} imagesLength={images.length} />
    </button>
  {/each}
</div>
